import { useSession } from 'contexts/session-context'
import Edit from 'icons/edit'
import { Link } from 'react-router-dom'
import { DivProfileTitle, PProfileTitle } from 'theme/profile'
import { TextProfile, TextProfileSecondary } from 'views/profile/text.style'

function Address() {
  const [{ user }] = useSession()
  const name =
    user?.nickName ||
    (user?.firstName && user?.firstName.length > 20 ? user?.firstName.substring(0, 17) + '...' : user?.firstName)

  return (
    <>
      {user?.firstName && (
        <DivProfileTitle className="h-16 flex items-center px-10 w-screen">
          <PProfileTitle className="flex-grow  max-w-full">{name}</PProfileTitle>
          <Link to="/address/update">
            <Edit fill="currentColor" />
          </Link>
        </DivProfileTitle>
      )}
      <div className="font-bold text-2xl px-10 py-7 flex-1 flex break-all">
        <div className="flex-1">
          {user?.address &&
            (user?.address.street1 ? (
              <div>
                <TextProfileSecondary className="font-normal dinPro text-lg normal-case">
                  {user?.address?.street1}, {user?.address?.streetNumber},
                  {user?.address?.shippingDetails && <span> {user?.address?.shippingDetails},</span>}
                </TextProfileSecondary>
                {user?.address?.street2 && (
                  <TextProfileSecondary className="font-normal dinPro text-lg normal-case">
                    {user?.address?.street2}
                  </TextProfileSecondary>
                )}
                <TextProfileSecondary className="font-normal dinPro text-lg normal-case">
                  {user?.address?.state},
                </TextProfileSecondary>
                <TextProfileSecondary className="font-normal dinPro text-lg normal-case">
                  {user?.address?.city},
                </TextProfileSecondary>
                <TextProfileSecondary className="font-normal dinPro text-lg normal-case">
                  {user?.address?.neighborhood},
                </TextProfileSecondary>
                <TextProfileSecondary className="font-normal dinPro text-lg normal-case">
                  CP {user?.address?.postalCode}
                </TextProfileSecondary>
              </div>
            ) : (
              <TextProfileSecondary className="font-normal dinPro text-lg normal-case">
                SIN INFORMACION
              </TextProfileSecondary>
            ))}
          {(user?.address?.curp && (
            <>
              <TextProfile className="mt-3">Documento de identidad (CURP)*</TextProfile>
              <TextProfileSecondary className="font-normal dinPro text-lg normal-case">
                {user?.address?.curp}
              </TextProfileSecondary>
            </>
          )) || (
            <TextProfileSecondary className="font-normal dinPro text-lg normal-case">
              SIN INFORMACION
            </TextProfileSecondary>
          )}
        </div>
        <div className="flex justify-start items-start"></div>
      </div>
    </>
  )
}

export default Address
